import React from "react";
import IncludedComponent from "../../Components/IncludedComponent";
import { SnackbarProvider } from "notistack";
function IncludedPage() {
  return (
    <SnackbarProvider>
      <div className="main-wrapper">
        <div className="content-wrapper">
          <IncludedComponent />
        </div>
      </div>
    </SnackbarProvider>
  );
}

export default IncludedPage;
